import { FIELD_VALUE_TYPE, SEARCH_RULE_TYPE } from '@constants'
import { ConfiguredColumn, RestrictionData } from '@types'

import { getColumnFieldName, getColumnFieldNameForSort } from './getColumnFieldName'
import { getIsAvailableRuleByType } from './getIsAvailableRuleByType'
import { isColumnPinnedByAdmin } from './isColumnPinnedByAdmin'

export const getInitialColumnVisibilityModel = (
  viewColumns: ConfiguredColumn[],
  needSortKey?: boolean,
  rule?: SEARCH_RULE_TYPE,
  defaultEntityRestrictions?: RestrictionData
) => {
  return Object.fromEntries(
    viewColumns.map(column => {
      const isColumnPinnedByAdminValue = isColumnPinnedByAdmin(
        column?.code,
        defaultEntityRestrictions
      )

      // Если колонка закреплена администратором, она всегда видима
      let isColumnVisible = isColumnPinnedByAdminValue

      if (!isColumnVisible) {
        isColumnVisible = rule
          ? Boolean(
              column &&
                getIsAvailableRuleByType(column, rule) &&
                column.valueType !== FIELD_VALUE_TYPE.BOOLEAN &&
                column.restrictions?.show !== 'false' &&
                column.restrictions?.show !== false
            )
          : true
        if (column?.restrictions?.show !== undefined && !rule) {
          if (typeof column?.restrictions?.show === 'string') {
            isColumnVisible = JSON.parse(column?.restrictions?.show)
          }
          if (typeof column?.restrictions?.show === 'boolean') {
            isColumnVisible = column?.restrictions?.show
          }
        }
      }

      return needSortKey
        ? [getColumnFieldNameForSort(column), isColumnVisible]
        : [getColumnFieldName(column), isColumnVisible]
    })
  )
}
